import React from 'react';
import { Spin, Typography } from 'antd';
import { Helmet } from 'react-helmet';
import './Payouts.scss';
import OverviewLayout from '../../OverviewLayout/OverviewLayout';
import PayoutMethods from './PayoutMethods';
import PayoutsList from './OwnerPayouts/PayoutsList';

const Payouts = () => {
  return (
    <OverviewLayout>
      <Helmet>
        <title>Payouts</title>
      </Helmet>
      <Spin spinning={false}>
        <div className="OverviewPayouts">
          <div className="OverviewSales_header">
            <Typography.Title className="OverviewSales_title" level={1}>
              Payouts
            </Typography.Title>
          </div>
          <PayoutMethods />
          <br />
          <PayoutsList />
          <br />
        </div>
      </Spin>
    </OverviewLayout>
  );
};

export default Payouts;
